// extracted by mini-css-extract-plugin
export default {"tcoButton":"E-Z7qR"};